import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ARTICLES, CATEGORIES } from "../data/content";
import { ArticleCardGrid } from "../components/ArticleCard";
import { Reveal } from "../components/Reveal";

export default function WritingsPage() {
  const [filter, setFilter] = useState("All Writings");
  const list =
    filter === "All Writings"
      ? ARTICLES
      : ARTICLES.filter((a) => a.category === filter);

  return (
    <div data-testid="writings-page">
      <section className="relative pt-36 lg:pt-44 pb-10 lg:pb-14 bg-[var(--surface)] border-b border-[var(--border-c)]">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
          <motion.span
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-mono text-xs uppercase tracking-[0.28em] text-[var(--gold)]"
          >
            Devata.org · Journal & Archive
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.08 }}
            className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[var(--text)] max-w-3xl"
          >
            Writings on the devata, dance &amp; history of Angkor
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.14 }}
            className="mt-6 font-sans text-base sm:text-lg leading-relaxed text-[var(--text-2)] max-w-xl"
          >
            Authentic field notes, book reviews and historical essays —
            gathered over two decades of research.
          </motion.p>
        </div>
      </section>

      <section className="relative py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
          <div
            data-testid="blog-category-filter"
            className="flex flex-wrap gap-2.5"
          >
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
                className={`rounded-full px-4 py-2 font-mono text-[11px] uppercase tracking-[0.12em] transition-colors duration-300 border ${
                  filter === c
                    ? "bg-[var(--ink)] text-[var(--bg)] border-[var(--ink)]"
                    : "bg-transparent text-[var(--text-2)] border-[var(--border-c)] hover:border-[var(--gold)]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={filter}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.4 }}
              className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14"
            >
              {list.map((a) => (
                <ArticleCardGrid key={a.id} article={a} />
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
      </section>
    </div>
  );
}
